import { createContext, useContext } from "react";

export type SidePaneContentType = 'chat' | 'participants';

export type AppContextType = {
    isSidePaneOpen: boolean;
    setIsSidePaneOpen: (isOpen: boolean) => void;

    sidePaneContent: SidePaneContentType[];
    addSidePaneContent: (content: SidePaneContentType) => void;
    removeSidePaneContent: (content: SidePaneContentType) => void;
    toggleSidePaneContent: (content: SidePaneContentType) => void;
}

export const AppContext = createContext<AppContextType | undefined>(undefined);

export const useAppContext = (): AppContextType => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error("useAppContext must be used within a AppContextProvider");
    }
    return context;
}
